import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
  buttonTypography,
} from "../typography/MuiTypography.style";
import { MuiGrid } from "../grid/MuiGrid";

export const AppLayoutWrapper = styled.div`
  html {
    scroll-behavior: smooth;
  }

  .skip-to-content {
    background-color: ${COLORS.cirrus_black2};
    border-radius: 16px;
    color: ${COLORS.primary_light_blue};
    font-weight: bold;
    left: 24px;
    padding: 16px 32px;
    position: absolute;
    transform: translateY(-120%);
    transition: transform 325ms ease-in;
    border: 2px solid ${COLORS.primary_light_blue};
    ${buttonTypography};

    &:focus {
      transform: translateY(5px);
    }
  }

  .app-layout-container {
    max-width: 100%;
    box-sizing: border-box;
    padding: 0px 16px;
    ${responsive.MOBILE`
      padding:0px 8px;
    `}
  }

  .content-container {
    background-color: ${COLORS.cirrus_black1};
    flex-grow: 1;
    height: 100vh;
    overflow: auto;
  }

  .side-bar-main {
    position: relative;
    padding-right: 0px;

    aside {
      overflow-y: auto;
      overflow-x: hidden;
      height: 100vh;
    }

    .side-bar-collapse-icon {
      position: absolute;
      background: linear-gradient(
        to left,
        ${COLORS.primary_light_blue6} 50%,
        transparent 50%
      );
      color: ${COLORS.cirrus_white};
      padding: 10px 0px 10px 20px;
      min-width: 19px;
      border-radius: 0% 50% 50% 0%;
      z-index: 5;
      top: 30px;
      right: -16px;
      height: 36px;
      transition: 0.1s;
      .left-arrow,
      .right-arrow {
        width: 12px;
        margin-right: 1px;
      }
      .right-arrow {
        margin-right: 3px;
      }

      &:hover {
        background: ${COLORS.primary_light_blue6};
        min-width: 32px;
        padding-left: 12px;
        right: -32px;
        transition: 0.2s;
        .left-arrow,
        .right-arrow {
          width: 15px;
        }
      }
    }
  }

  .grid-container {
    height: 100vh;
  }

  .desktop-sidebar {
    max-width: 360px;
  }

  .desktop-right-content {
    width: calc(100% - 360px);
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mui-link {
    ${h3Regular}
    ${fontWeightBold}
    text-decoration: none;
    color: ${COLORS.primary_light_blue};
  }

  .grid-size-large {
    padding-right: 16px;
    margin-top: 40px;

    &:nth-child(-n + 2) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      padding-right: 0;
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+1) {
        margin-top: 16px;
      }
    `}
  }

  .grid-size-large-full {
    padding-right: 16px;
    margin-top: 40px;
    &:nth-child(-n + 3) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+3) {
        margin-top: 16px;
      }
    `}
  }

  .grid-size-medium-full {
    padding-right: 16px;
    margin-top: 40px;
    &:nth-child(-n + 4) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }

  .grid-size-medium {
    padding-right: 16px;
    margin-top: 24px;
  
    &:nth-child(-n + 3) {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 24px;
      }
      &:nth-child(n+3) {
        margin-top: 24px;
      }
    `}

    ${responsive.MOBILE`
     padding-right: 0px;
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }
`;

export const ConditionalGrid = styled(MuiGrid)<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? "block" : "none")};
`;
